<template>
  <v-card
    class="question-form">
    <v-card-title
      primary-title>
      <v-row
        class="form-header">
        <span class="title font-weight-bold">
          {{ renderTitle }}
        </span>
        <v-spacer />

        <v-menu
          left
          bottom
          nudge-top="20"
          nudge-right="200"
          content-class="menu-export-expose"
          :close-on-content-click="false"
          v-model="isExportExposeMenuActive"
          v-if="candidate">
          <template v-slot:activator="{ on }">
            <v-btn
              depressed
              :disabled="readOnlyMode"
              class="btn-export-expose"
              v-on="on">
              <v-icon>
                mdi-email-outline
              </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-text>
              <v-text-field
                outlined
                dense
                label="E-Mail-Adresse"
                v-on:keyup.enter="onClickExportExpose"
                v-model="email"
                ref="exportexposemail" />
                <v-btn
                  color="primary"
                  depressed
                  :disabled="isLoadingExportExpose"
                  :loading="isLoadingExportExpose"
                  @click="onClickExportExpose">
                  Exposé senden
                </v-btn>
            </v-card-text>
          </v-card>
        </v-menu>
        <v-select
          v-if="possibleCandidateStates && possibleCandidateStates.length"
          :items="possibleCandidateStates"
          outlined
          dense
          :disabled="!canEditCandidate || readOnlyMode"
          return-object
          item-text="label"
          ref="candidateStateSelect"
          @change="onChangeCandidateState"
          v-model="candidateStatus" />
      </v-row>

      <v-row
        v-if="hasOpenMandatoryQuestions"
        class="form-progress-hint">
        <v-icon
          small
          color="error">
          mdi-alert-circle
        </v-icon>
        <label
          class="caption">
          Fehlende erforderliche Angaben<br>
          <span>{{ openMandatoryQuestionsLabels }}</span>
        </label>
      </v-row>
      <v-row
        v-else
        class="form-progress-hint">
        <v-icon
          small
          color="success">
          mdi-check-circle
        </v-icon>
        <label
          class="caption">
          Alle erforderlichen Angaben vorhanden.
        </label>
      </v-row>

      <v-row
        v-if="hasPermissionToVerifyCandidate && hasOpenMandatoryVerifications"
        class="form-progress-hint">
        <v-icon
          small
          color="error">
          mdi-alert-circle
        </v-icon>
        <label
          class="caption">
          Fehlende Verifikationen<br>
          <span>{{ openMandatoryVerificationsLabels }}</span>
        </label>
      </v-row>
      <v-row
        v-if="hasPermissionToVerifyCandidate && !hasOpenMandatoryVerifications"
        class="form-progress-hint">
        <v-icon
          small
          color="success">
          mdi-check-circle
        </v-icon>
        <label
          class="caption">
          Alle Angaben sind verifiziert.
        </label>
      </v-row>

      <!--<v-row
        v-if="!isCandidatePromoted"
        class="form-progress-hint">
        <v-icon
          small
          color="error">
          mdi-alert-circle
        </v-icon>
        <label
          class="caption">
          Bewerber noch nicht in Disposition übernommen.
        </label>
      </v-row>-->
      <v-row
        v-if="isCandidatePromoted"
        class="form-progress-hint">
        <v-icon
          small
          color="success">
          mdi-check-circle
        </v-icon>
        <label
          class="caption">
          Bewerber bereits in Disposition übernommen.
        </label>
      </v-row>

    </v-card-title>
    <v-card-text>

      <QuestionFormCategory
        v-for="category in categoriesToRender"
        :key="category.key"
        :category="category"
        :answers="answers"
        @change-answer="onChangeAnswer"
        :readonly="!canEditCandidate" />

      <InputDSB
        v-model="hasAcceptedDSB"
        label="Der Bewerber akzeptiert Datenschutzbestimmungen." />

    </v-card-text>
    <div v-if="questionFormError" class="caption red--text questionError">{{questionFormError}}</div>
    <v-card-actions>
      <v-btn
          v-if="canEditCandidate"
          :loading="isSavingCandidate"
          @click="onClickSave"
          depressed
          color="primary"
          :disabled="!(canSaveCandidate && shouldSaveCandidate)">
          Speichern
  </v-btn>
      <v-btn
        v-if="canEditCandidate"
        depressed
        @click="onClickCancel">
        Abbrechen
      </v-btn>
      <v-btn
        v-if="!canEditCandidate"
        @click="onClickCancel"
        depressed
        color="primary">
        Ok
      </v-btn>
      <v-spacer />
      <v-btn
        v-if="canPromoteCandidate"
        @click="showPromotionDialog"
        depressed
        color="primary">
        In die Disposition übernehmen
      </v-btn>
    </v-card-actions>

    <VDialogExt
      width="480"
      content-class="dialog-cannot-save-employed"
      v-model="isCannotSaveEmployedStateDialogActive"
      v-if="candidateStatus">
      <v-card>
        <v-card-title>
          Hinweis
        </v-card-title>
        <v-card-text>
          Um den Bewerber mit dem Status <strong>{{ candidateStatus.label }}</strong> speichern zu können, fehlen einige Bedingungen.
          <div
            v-if="hasOpenMandatoryQuestions">
            Fehlende erforderliche Angaben ausfüllen:<br>
            <span>{{ openMandatoryQuestionsLabels }}</span>
          </div>
          <div
            v-if="hasOpenMandatoryVerifications">
            Felder verifizieren:<br>
            <span>{{ openMandatoryVerificationsLabels }}</span>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            depressed
            color="primary"
            @click="isCannotSaveEmployedStateDialogActive = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </VDialogExt>

    <VDialogExt
      width="480"
      persistent
      content-class="dialog-promote-double-check"
      v-model="isShouldPromoteDialogActive"
      v-if="candidate">
      <v-card>
        <v-card-title>
          Bewerber übernehmen
        </v-card-title>
        <v-card-text>
          Möchten Sie den Bewerber wirklich in die Disposition übernehmen und Ihm eine Einladungsmail zuschicken?
        </v-card-text>
        <v-card-subtitle class="red--text">{{createUserError}}</v-card-subtitle>
        <v-card-actions>
          <v-btn
            depressed
            :loading="isCreatingEmployee"
            color="primary"
            @click="createEmployee">
            Ja, Bewerber übernehmen
          </v-btn>
          <v-btn
            depressed
            @click="closePromotionDialog">
            Abbrechen
          </v-btn>
        </v-card-actions>
      </v-card>
    </VDialogExt>

    <VDialogExt
      width="480"
      persistent
      content-class="dialog-promote-double-check"
      v-model="showSendRejectionMailDialog"
      v-if="candidate">
      <v-card>
        <v-card-title>
          Bewerber ablehnen
        </v-card-title>
        <v-card-text>
          Möchten Sie dem Bewerber eine automatische Absagemail senden?
        </v-card-text>
        <v-card-actions>
          <v-btn
            depressed
            color="primary"
            @click="rejectionMailFlow">
            Ja, Mail versenden
          </v-btn>
          <v-btn
            depressed
            @click="noRejectionMailFlow">
            Nein, keine Mail versenden
          </v-btn>
        </v-card-actions>
      </v-card>
    </VDialogExt>
  </v-card>
</template>

<script>
import QuestionFormCategory from './questions/QuestionFormCategory'
import InputDSB from '@/components/inputs/InputDSB'
import VDialogExt from '@/components/VDialogExt'
import BL from '@/bl/bl'
import StatusBL from '@/bl/statusBl'
import CandidateBL from '@/bl/candidateBl'

export default {
  name: 'QuestionForm',

  props: {
    candidate: {
      type: Object,
      default: void 0
    }
  },

  components: {
    QuestionFormCategory,
    InputDSB,
    VDialogExt
  },

  mounted () {
    window.$form = this
  },

  data () {
    return {
      // Deep copy passed answers (if passed) so we can work with a local, reactive copy
      answers: this.candidate ? JSON.parse(JSON.stringify(this.candidate.answers)) || [] : [],

      // Do the same for the candidate states and its status
      candidateStatus: this.candidate ? JSON.parse(JSON.stringify(StatusBL.getStatusForCandidate(this.candidate))) : void 0,
      possibleCandidateStates: this.candidate ? JSON.parse(JSON.stringify(StatusBL.getPossibleStatesForCandidate(this.candidate))) : [],

      hasAcceptedDSB: BL.candidateHasAcceptedDSB(this.candidate),

      isExportExposeMenuActive: false,
      isLoadingExportExpose: false,
      email: '',

      isCannotSaveEmployedStateDialogActive: false,
      isShouldPromoteDialogActive: false,
      isCreatingEmployee: false,
      createUserError: '',
      statusSwitchedToRejection: false,
      showSendRejectionMailDialog: false,
      questionFormError: '',
      isSavingCandidate: false
    }
  },

  watch: {
    hasAcceptedDSB (val) {
      BL.updateCandidateDSB(this.candidate, val)
    },

    isExportExposeMenuActive (val) {
      val
        ? setTimeout(_ => {
          this.$refs.exportexposemail.focus()
        }, 100)
        : void 0
    }
  },

  computed: {
    categoriesToRender () {
      return BL.getCategoriesToRender(this.answers)
    },

    renderTitle () {
      const title = CandidateBL.getTitle(this.candidate, this.answers)
      const name = CandidateBL.getName(this.candidate, this.answers)

      if (title || name) {
        return [title, name].filter(e => !!e).join(' ')
      }

      return this.candidate
        ? 'Mitarbeiterinformationen'
        : 'Neuer Mitarbeiter'
    },

    openMandatoryVerifications () {
      const renderedQuestions = BL.getQuestionsToRender(this.answers)
      return BL.getMandatoryQuestionsWithoutVerification(renderedQuestions, this.answers)
    },

    openMandatoryVerificationsLabels () {
      return this.openMandatoryVerifications && this.openMandatoryVerifications
        ? this.openMandatoryVerifications.map(question => question.form_label).join(', ')
        : void 0
    },

    hasOpenMandatoryVerifications () {
      return this.openMandatoryVerifications.length !== 0
    },

    openMandatoryQuestions () {
      const renderedQuestions = BL.getQuestionsToRender(this.answers)
      return BL.getMandatoryQuestionsWithoutAnswers(renderedQuestions, this.answers)
    },

    openMandatoryQuestionsLabels () {
      return this.openMandatoryQuestions && this.openMandatoryQuestions
        ? this.openMandatoryQuestions.map(question => question.form_label).join(', ')
        : void 0
    },

    hasOpenMandatoryQuestions () {
      return this.openMandatoryQuestions.length !== 0
    },

    canEditCandidate () {
      return !this.readOnlyMode && BL.canEditCandidate(this.candidate)
    },

    canSaveCandidate () {
      return !this.readOnlyMode && this.hasAcceptedDSB
    },

    canPromoteCandidate () {
      return !this.readOnlyMode && BL.canPromoteCandidate(this.candidate, this.answers, this.candidateStatus)
    },

    isCandidatePromoted () {
      return CandidateBL.isPromoted(this.candidate)
    },

    shouldSaveCandidate () {
      const savedAnswers = this.candidate ? this.candidate.answers : []
      const savedStatus = this.candidate ? StatusBL.getStatusForCandidate(this.candidate) : void 0

      if (this.candidateStatus && savedStatus.value !== this.candidateStatus.value) {
        return true
      }

      if (savedAnswers.length !== this.answers.length) {
        return true
      }

      const hasAnswerDiff = this.answers.find(answer => {
        const savedVersion = savedAnswers.find(sa => sa.question_key === answer.question_key)
        if (!savedVersion) {
          return true
        }

        const value1 = savedVersion.answer
        const value2 = answer.answer
        if (Array.isArray(value1) || Array.isArray(value2)) {
          if (!Array.isArray(value1) || !Array.isArray(value2) || value1.length !== value2.length) {
            return true
          }

          if (value1.concat().sort().join('') !== value2.concat().sort().join('')) {
            return true
          }
        } else {
          if (value1 !== value2) {
            return true
          }
        }

        const verification1 = savedVersion.verification
        const verification2 = answer.verification
        if (!verification1 || !verification2 || verification1.status !== verification2.status || verification1.comment !== verification2.comment) {
          return true
        }

        return false
      }) !== void 0

      return hasAnswerDiff
    },

    readOnlyMode () {
      return this.$store.getters['readOnlyMode']
    }
  },

  methods: {
    onChangeCandidateState () {
      this.$nextTick(_ => {
        if (this.candidateStatus.value === StatusBL.states.STATUS_CANCELLED) {
          this.statusSwitchedToRejection = true
        } else {
          this.statusSwitchedToRejection = false
        }
        this.$refs && this.$refs.candidateStateSelect
          ? this.$refs.candidateStateSelect.blur()
          : void 0
      })
    },

    onChangeAnswer () {
      return true
    },

    onClickSave () {
      if (!this.canSaveCandidate) {
        return
      }

      if (this.statusSwitchedToRejection) {
        this.showSendRejectionMailDialog = true
        return
      }

      this.isSavingCandidate = true
      this.saveCandidate()
        .then(_ => {
          this.isSavingCandidate = false
          this.$emit('close')
        })
        .catch(_ => {
          this.isSavingCandidate = false
          this.questionFormError = 'Fehler beim Speichern des Kandidaten'
        })
    },

    saveCandidate () {
      if (!this.canSaveCandidate) {
        return Promise.reject(new Error('Kandidat kann nicht gespeichert werden'))
      }

      if (this.candidateStatus) {
        StatusBL.setStatusForCandidate(this.candidate, this.candidateStatus)
      }

      return this.candidate
        ? BL.saveAnswersForCandidate(this.answers, this.candidate)
        : BL.upsertCandidateAndSaveWithAnswers(this.answers)
    },

    onClickCancel () {
      this.$emit('close')
    },

    onClickExportExpose () {
      this.isLoadingExportExpose = true

      BL.exportCandidate(this.candidate, this.email)
        .then(_ => {
          this.isExportExposeMenuActive = false
        })
        .catch(_ => {
          alert('Beim Senden des Exposes ist ein Fehler aufgetreten')
        })
        .finally(_ => {
          this.isLoadingExportExpose = false
        })
    },

    showPromotionDialog () {
      if (!this.canSaveCandidate) {
        return
      }

      if (
        (this.hasOpenMandatoryQuestions) ||
        (this.hasOpenMandatoryVerifications)
      ) {
        this.isCannotSaveEmployedStateDialogActive = true
        return
      }

      if (this.candidateStatus) {
        StatusBL.setStatusForCandidate(this.candidate, this.candidateStatus)
      }

      this.isShouldPromoteDialogActive = true
    },

    closePromotionDialog () {
      this.isShouldPromoteDialogActive = false
      this.createUserError = ''
    },

    createEmployee () {
      this.isCreatingEmployee = true
      this.createUserError = ''
      BL.createEmployee(this.candidate, this.answers)
        .then(_ => {
          this.isShouldPromoteDialogActive = false
        })
        .catch(err => {
          let errorString = ''
          try {
            errorString = err.response.data
            if (errorString.includes('UserCreate: invalid email')) {
              this.createUserError = 'Email ist bereits vergeben'
            } else {
              this.createUserError = 'Fehler beim Anlegen des Mitarbeiters: ' + errorString
            }
          } catch (e) {
            this.createUserError = 'Unbekannter Fehler beim Anlegen des Mitarbeiters. '
          }
        })
        .finally(_ => {
          this.isCreatingEmployee = false
        })
    },

    rejectionMailFlow () {
      this.showSendRejectionMailDialog = false
      this.isSavingCandidate = false
      this.saveCandidate()
        .then(_ => {
          return BL
            .sendRejectionMail(this.candidate.uuid)
            .then(_ => {
              this.isSavingCandidate = false
              this.$emit('close')
            })
            .catch(_ => {
              this.isSavingCandidate = false
              this.questionFormError = 'Fehler beim Senden der Mail an den Kandidaten'
            })
        })
        .catch(_ => {
          this.isSavingCandidate = false
          this.questionFormError = 'Fehler beim Speichern des Kandidaten'
        })
    },

    noRejectionMailFlow () {
      this.showSendRejectionMailDialog = false
      this.isSavingCandidate = true
      this.saveCandidate()
        .then(_ => {
          this.isSavingCandidate = false
          this.$emit('close')
        })
        .catch(_ => {
          this.isSavingCandidate = false
          this.questionFormError = 'Fehler beim Speichern des Kandidaten'
        })
    }
  }
}
</script>

<style lang="scss">
  .question-form {
    .v-card__title {
      padding-top: 1.5em !important;
      padding-bottom: 1.5em !important;
      background: #f5f5f5;
      flex-direction: column;

      .row {
        margin-left: 0;
        margin-right: 0;
        width: 100%;
        align-items: center;

        &.form-header {
          margin-bottom: 0.5em;
          flex-wrap: nowrap;

          .title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 1em;
          }
        }

        &.form-progress-hint {
          flex-wrap: nowrap;
          align-items: flex-start;
          margin-top: 0.5em;

          label {
            margin-left: 0.5em;
            line-height: 1.25em;
            min-width: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            span {
              opacity: 0.5;
            }
          }
        }

        .v-select {
          flex: 0 0 12em;
          font-weight: normal;
          .v-input__control {
            .v-input__slot {
              margin-bottom: 0;
              background-color: #e5e5e5;
            }
            fieldset {
              border-color: transparent !important;
            }
            .v-text-field__details {
              display: none;
            }
          }
        }
      }
    }

    .btn-export-expose {
      margin-right: 1em;
    }

    .btn-export-expose:before {
      opacity: 0.08;
    }

    .questionError {
      margin-left: 2em;
    }
  }

  .menu-export-expose {
    box-shadow: 0 16px 32px rgba(0,0,0,0.1);
    width: 480px;

    .v-card {
      .v-card__text {
        display: flex;
        align-items: center;

        .v-text-field {
          margin-bottom: 0;
          margin-right: 1em;

          .v-input__slot {
            margin-bottom: 0;
          }

          .v-text-field__details {
            display: none;
          }
        }
      }
    }
  }

  .dialog-cannot-save-employed {
    .v-card__text {
      div {
        margin-top: 1em;
        background: #f5f5f5;
        border-radius: 4px;
        padding: 1em;
        font-weight: bold;

        span {
          font-weight: normal;
        }
      }
    }
  }
</style>
